<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="!changed"
    :title="editing ? 'ویرایش کاربر' : 'افزودن کاربر'"
    width="580px"
  >
    <el-form @submit.native.prevent="submit">
      <el-row :gutter="10">
        <el-col :sm="12" class="mb-3">
          <label class="font-9 required">نام</label>
          <el-input
            ref="name"
            key="field-name"
            v-model="form.name"
            v-validate="'required'"
            v-focus
            data-vv-as="نام"
            placeholder="نام"
          />
        </el-col>
        <el-col :sm="12" class="mb-3">
          <label class="font-9 required">شماره موبایل</label>
          <el-input
            ref="mobile"
            key="field-phone"
            v-model="form.mobile"
            v-validate="'required|mobile'"
            v-number.numeric="true"
            type="tel"
            data-vv-as="شماره موبایل"
            placeholder="شماره موبایل"
          />
        </el-col>
        <el-col :sm="12" class="mb-3">
          <p class="font-9">جنسیت</p>
          <el-select v-model="form.gender" placeholder="آقا/خانم" clearable>
            <el-option
              v-for="item in $enums.getArrayWithKey('gender')"
              :key="item.id"
              :value="item.value"
              :label="item.title"
            />
          </el-select>
        </el-col>
        <el-col :sm="12" class="mb-3">
          <p class="font-9 required">نقش</p>
          <el-select
            key="field-role"
            v-model="form.role"
            v-validate="'required'"
            placeholder="نقش"
            data-vv-as="نقش"
            clearable
          >
            <el-option
              v-for="item in allRoles"
              :key="item.id"
              :value="item.name"
              :label="item.title"
            />
          </el-select>
        </el-col>
        <el-col v-if="editing" :span="24" :xs="24" class="mb-4">
          <el-button @click="creditVisible = true">ویرایش شارژ اکانت</el-button>
          <div style="clear: both"></div>
        </el-col>
        <el-col v-show="!editing" :sm="12" class="mb-3">
          <p class="font-9 required">رمز کاربری</p>
          <el-input
            v-if="!editing"
            key="field-password"
            v-model="form.password"
            v-validate="'required'"
            placeholder="رمز کاربری"
            data-vv-as="رمز کاربری"
            type="password"
          />
        </el-col>
        <el-col v-show="!editing" :sm="12" class="mb-3">
          <p class="font-9 required">تکرار رمز کاربری</p>
          <el-input
            v-if="!editing"
            key="field-confirm-password"
            v-model="form.confirmPassword"
            v-validate="{
              required: form.password ? true : false,
              confirmPassword: form.password
            }"
            placeholder="تکرار رمز کاربری"
            data-vv-as="تکرار رمز کاربری"
            type="password"
          />
        </el-col>
      </el-row>
      <div class="text-center" style="margin:20px 0 -10px">
        <el-button type="primary" native-type="submit" :loading="addLoading">
          ثبت
        </el-button>
        <el-button :disabled="addLoading" @click="visible = false">
          انصراف
        </el-button>
      </div>
    </el-form>
    <credit-form
      :show.sync="creditVisible"
      :user.sync="user"
      @updateTable="$emit('updateTable')"
    />
  </el-dialog>
</template>

<script>
import MutationCreate from '@/graphql/user/Create.gql'
import MutationUpdate from '@/graphql/user/Update.gql'
import ItemQuery from '@/graphql/user/User.gql'
import 'vue-slider-component/theme/default.css'
import { allRoles } from '@/modules/user'
import { FormMixin } from '@/modules/mixins'
import CreditForm from './CreditForm.vue'

const NEW_FORM = [
  { name: 'name', type: 'string' },
  { name: 'mobile', type: 'string' },
  { name: 'role', type: 'string' },
  { name: 'gender', type: 'string' },
  { name: 'password', type: 'string' },
  { name: 'confirmPassword', type: 'string' }
]
const EDIT_FORM = [
  { name: 'credit', type: 'string' },
  { name: 'userId', type: 'string' },
  { name: 'name', type: 'string' },
  { name: 'mobile', type: 'string' },
  { name: 'role', type: 'string' },
  { name: 'gender', type: 'string' }
]

export default {
  name: 'UserForm',
  components: {
    CreditForm
  },
  mixins: [FormMixin],
  props: {
    editingId: { type: [String, Number], default: '' },
    editingItem: { type: Object, default: null },
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      addLoading: false,
      user: {},
      form: {},
      showBalance: false,
      creditVisible: false
    }
  },
  computed: {
    editing() {
      if (this.editingId) return this.editingId
      if (this.editingItem) return this.editingItem.id
      return false
    },
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
    changed() {
      let item = this.reformatItem(this.user)
      let originalForm = this.createEditForm(EDIT_FORM, item)
      return JSON.stringify(this.form) !== JSON.stringify(originalForm)
    },
    allRoles() {
      return allRoles
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {})
      } else {
        this.$emit('update:editingId', null)
        this.$emit('update:editingItem', null)
      }

      this.creditVisible = false
      this.form = this.createNewForm(NEW_FORM)
    },
    editing: {
      immediate: false,
      handler(val) {
        if (val) {
          this.showBalance = false
          this.getItem()
          this.visible = true
        }
      }
    },
    user: {
      immediate: true,
      handler(val) {
        let item = this.reformatItem(val)
        this.form = this.createEditForm(EDIT_FORM, item)
      }
    }
  },
  methods: {
    getItem() {
      if (this.editingItem) return (this.user = { ...this.editingItem })
      this.user = null
      this.apollo
        .query({
          query: ItemQuery,
          variables: { id: this.editing }
        })
        .then(response => {
          this.user = response.data.user
        })
    },
    reformatItem(val) {
      if (!val) return {}
      let item = {
        userId: val.id,
        name: val.name,
        mobile: val.mobile,
        credit: val.credit
      }
      let roleData = this.$options.filters.roleData(val.role)
      let gender = this.$enums.gender[val.gender]
      item.role = roleData ? roleData.name : null
      item.gender = gender ? gender.value : null
      return item
    },
    submit() {
      this.$validate().then(() => {
        let user = { ...this.form }
        for (let k in user) {
          if (/*k !== 'description' && */ user[k] === '' || user[k] === null)
            this.$delete(user, k)
        }
        if (!this.editing) {
          delete user.confirmPassword
        }
        if (!this.showBalance) {
          delete user.credit
        }
        this.apollo
          .mutate({
            query: this.editing ? MutationUpdate : MutationCreate,
            variables: user,
            $loadingKey: 'addLoading'
          })
          .then(() => {
            this.$message.success('اطلاعات با موفقیت ثبت شد')
            this.visible = false
            this.$emit('updateTable')
          })
      })
    }
  }
}
</script>
